<div class="assign modal-content">
  <div class="modal-header">
    <h3 class="modal-title font-weight-bold">Location Alias Assignment</h3>
    <button (click)="close();" aria-label="Close" class="btn-close" type="button"></button>
  </div>
  <h3 class="modal-header modal-sub-title font-weight-bold">Assigned</h3>

  <ngx-simplebar [options]="options">
    <table class="table" style="overflow-y: scroll;">
      <thead class="body-head">
      <tr>
        <th>
        </th>
        <th>Dealer</th>
        <th>Location Alias</th>
        <th>State</th>
        <th>City</th>
        <th>Email</th>
        <th>Tel</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let locationAlias of this.assignedLocationAliases;" class="body">
        <td>
          <input (change)="onAssignChangeSelect($event)" [checked]="locationAlias.selected"
                 [value]="locationAlias._id"
                 class="unAssign-check-box"
                 type="checkbox">
        </td>
        <td>{{ locationAlias.dealerName }}</td>
        <td>{{ locationAlias.locationAlias }}</td>
        <td>{{ locationAlias.address.state }}</td>
        <td>{{ locationAlias.address.city }}</td>
        <td>{{ locationAlias.email }}</td>
        <td>{{ locationAlias.tel }}</td>
      </tr>
      </tbody>
    </table>
  </ngx-simplebar>

  <div>
    <div class="modal-footer">
      <button (click)="unAssignLocationAliases()"
              class="save btn btn-outline-dark"
              type="submit"
      >UnAssign
      </button>
    </div>
  </div>

  <h3 class="modal-header modal-sub-title font-weight-bold">Dealers</h3>

  <div class="row mb-0">
    <div class="col-lg-6 col-sm-6">
      <div class="row search-box">
        <div class="col-lg-6 position-relative">
          <ng-select (change)="changeDealer($event)"
                     [items]="dealerSelectGroup"
                     [multiple]="false"
                     bindLabel="name"
                     bindValue="code"
                     class="form-control"
                     placeholder="All Dealers">

          </ng-select>
        </div>
        <div class="col-lg-6 mb-2">
          <div class="position-relative">
            <input [formControl]="searchText"
                   class="form-control border-light rounded"
                   placeholder="Search For"
                   type="text">
            <i class="uil uil-search search-icon"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="table-wrapper">

      <app-dp-list (pageEvent)="onPageEvent($event)"
                   [pagedResponse]="pagedResponse"
                   [selectedItem]="selectedData">
        <table class="table">
          <thead class="body-head font-weight-bold">
          <th>
          </th>
          <th>Dealer</th>
          <th>Location Alias</th>
          <th>State</th>
          <th>City</th>
          <th>Email</th>
          <th>Tel</th>
          </thead>
          <tbody>
          <tr *ngFor="let dealerLocation of dealerLocations; let i = index" class="body">
            <td>
              <input (change)="onUnAssignChangeSelect($event)" [checked]="dealerLocation.isSelected"
                     [value]="dealerLocation._id"
                     class="assign-check-box"
                     type="checkbox">
            </td>
            <td>{{ dealerLocation.dealerName }}</td>
            <td>{{ dealerLocation.locationAlias }}</td>
            <td>{{ dealerLocation.address?.state }}</td>
            <td>{{ dealerLocation.address?.city }}</td>
            <td>{{ dealerLocation.email }}</td>
            <td>{{ dealerLocation.tel }}</td>
          </tr>
          </tbody>
        </table>
      </app-dp-list>
    </div>

    <div>
      <div class="modal-footer">
        <button (click)="assignLocationAliases()"
                class="save btn btn-dark"
                type="submit"
        >Assign
        </button>
      </div>
    </div>

  </div>
</div>
